import { render, staticRenderFns } from "./C-PersonInfo.vue?vue&type=template&id=7dd8f65f&scoped=true&"
import script from "./C-PersonInfo.vue?vue&type=script&lang=js&"
export * from "./C-PersonInfo.vue?vue&type=script&lang=js&"
import style0 from "./C-PersonInfo.vue?vue&type=style&index=0&id=7dd8f65f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd8f65f",
  null
  
)

export default component.exports